var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47Z",
    fill: "#5F9E87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.464 33C19.4077 33 19.3655 33 19.3092 33C18.7602 32.9581 18.2676 32.6507 17.972 32.1896L12.2573 22.9393C11.7505 22.1289 12.018 21.0669 12.8344 20.5639C13.6508 20.0609 14.7205 20.3263 15.2272 21.1368L19.7174 28.3889L31.9632 14.5834C32.5966 13.8707 33.6945 13.8009 34.4124 14.4297C35.1302 15.0585 35.2006 16.1484 34.5672 16.861L20.773 32.4271C20.4352 32.7904 19.9567 33 19.464 33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/icon-ok.47943e592e4e2ba1972e7ee8233016e4.svg";
export { ForwardRef as ReactComponent };